export const TERM_URL = "https://termurl.com";
